<template lang="pug">
header(:class="{ expand: isNavExpand }")
  nav.expand.navbar.fixed-top.navbar-light.shadow.bg_white
    .container.position-relative
      a.navbar-brand(href="/")
        img.d-inline-block.align-top(
          v-if="companyInformation.logo",
          :src="companyInformation.logo.image",
          alt="",
          loading="lazy"
        )
        | &#32;
        span {{ companyInformation.slogan }}
      .menu
        a.menu-mobile(@click="isNavExpand = !isNavExpand")
          svg-icon(iconClass="bars-solid", className="icon")
        ul.main
          custom-link(
            :title="'Application'",
            :list="allNavigation.application"
          )
          | &#32;
          li.i_mt_sm_2(@mouseover="hover = true", @mouseleave="hover = false")
            a(@click="isMultiMenuExpand = !isMultiMenuExpand") Product
            ul.multi-sub(
              :class="[{ hover: hover }, { expand: isMultiMenuExpand }]"
            )
              li
                a IC
                ul
                  sublink(
                    @hideSubMenu="hideSubMenu",
                    v-for="(subLink, index) in allNavigation.product_ic",
                    :key="index",
                    :subLink="subLink"
                  )
              li
                a Controller Board
                ul
                  sublink(
                    @hideSubMenu="hideSubMenu",
                    v-for="(subLink, index) in allNavigation.product_module",
                    :key="index",
                    :subLink="subLink"
                  )
              li
                a Assesory
                ul
                  sublink(
                    @hideSubMenu="hideSubMenu",
                    v-for="(subLink, index) in allNavigation.product_accessory",
                    :key="index",
                    :subLink="subLink"
                  )
          | &#32;
          custom-link(
            :title="'Design Support'",
            :list="allNavigation.design_support"
          )
          | &#32;
          custom-link(:title="'Technology'", :list="allNavigation.technology")
          | &#32;
          custom-link(:title="'Company'", :list="allNavigation.company")
      .icon-link
        .dropdown
          button.btn.dropdown-toggle.btn-sm(
            type="button",
            @click="langExpand = !langExpand"
          )
            font-awesome-icon(:icon="['fas', 'globe-europe']")
            | &#32;
            .dropdown-menu(:class="{ show: langExpand }")
              a.dropdown-item(@click="changeToEnglish") EN
              a.dropdown-item(@click="changeToChinese") CN
        | &#32;
        a(v-if="!this.$store.state.user.accessToken", href="/login")
          font-awesome-icon(
            v-b-tooltip.hover.bottom="'Login'",
            :icon="['far', 'user']"
          )
        a(v-else, href="/memberportal")
          font-awesome-icon(
            v-b-tooltip.hover.bottom="'Member Portal'",
            :icon="['fas', 'user']"
          )
</template>

<script>
import Link from "@/components/common/Navigation/Link";
import Sublink from "@/components/common/Navigation/Sublink";
import "@/assets/style/main.scss";
import { getCompanyInformation, getNavigation } from "@/api/company";
import { setLanguage } from "@/utils/auth";

export default {
  data() {
    return {
      hover: false,
      langExpand: false,
      allNavigation: {},
      companyInformation: {},

      tempAccessory: [],

      isMultiMenuExpand: false,
      isNavExpand: false,
    };
  },
  components: {
    "custom-link": Link,
    sublink: Sublink,
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getCompanyInformation();
      this.getNavigation();
    },
    hideSubMenu() {
      this.hover = false;
    },
    getCompanyInformation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getCompanyInformation(temp).then((response) => {
        this.companyInformation = response.data;
      });
    },
    getNavigation() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getNavigation(temp).then((response) => {
        this.allNavigation = response.data;
      });
    },
    changeToEnglish() {
      this.$store.state.user.language = "en";
      setLanguage("en");
    },
    changeToChinese() {
      this.$store.state.user.language = "zh_tw";
      setLanguage("zh_tw");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/navigation";
</style>
